import React, { useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import ModelFooterButtons from "./modelFooterButtons";
import { useSelector } from "react-redux";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const EditCustomerModal = ({ isOpen, onClose, onSave, customer }) => {
  console.log(customer, "customercustomer");
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const userProfile = useSelector((state)=> state?.auth?.userProfile?.role?.name)
  const isFieldDisabled = userProfile ==="Admin" ? false : true
  // const roles = useSelector((state) => state?.auth?.roles);
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@(?!gmail\.com$|yahoo\.com$|outlook\.com$|hotmail\.com$|icloud\.com$|aol\.com$|zoho\.com$|protonmail\.com$)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const nameRegex = /^[a-zA-Z\s]+$/;
  const AddCustomerValidationSchema = Yup.object().shape({
    organization_name: Yup.string()
      .required("First Name is required")
      .max(36, "First Name must be at most 36 characters long"),
    org_contact_person_first_name: Yup.string()
      .matches(nameRegex, "First Name must contain only letters and spaces")
      .required("First Name is required")
      .max(36, "First Name must be at most 36 characters long"),
    org_contact_person_last_name: Yup.string()
      .matches(nameRegex, "Last Name must contain only letters and spaces")
      .required("Last Name is required")
      .max(36, "Last Name must be at most 36 characters long"),
    org_contact_person_email: Yup.string()
      .matches(emailRegex, "Enter a valid email address")
      .max(254, "Email must be at most 254 characters.")
      .required("Email is required"),
    org_contact_person_phone_number: Yup.string()
      .required("Phone Number is required"),
    authorization_code:Yup.string()
      .max(6, "Authorization Code must be at most 6 characters long")
      .matches(/^[a-zA-Z0-9]{6}$/, "Authorization Code must have 6 character and can contain only letters and numbers")
      .required("Authorization Code is required"),
  });

  const styles = {
    formItem: {
      mt: 4,
    },
    input: {
      size: "sm",
      borderRadius: 6,
    },
  };
  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Customer</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={2}>
            <Formik
              initialValues={{
                organization_name: customer?.name || "",
                org_contact_person_email: customer?.email || "",
                org_contact_person_first_name: customer?.first_name || "",
                org_contact_person_last_name: customer?.last_name || "",
                org_contact_person_phone_number: customer?.phone_number || "",
                postal_code: customer?.location?.postalcode || "",
                organization_address: customer?.location?.address || "",
                postal_code: customer?.location?.postalcode || "",
                authorization_code: customer?.authorization_code || "",
                // privilege:
                //   roles.find((role) => role.name === customer.privilege)?.id ||
                //   "",
              }}
              validationSchema={AddCustomerValidationSchema}
              onSubmit={(values) => {
                onSave(values);
              }}
            >
              {({ handleSubmit, errors, touched, values, setFieldValue }) => (
                <form onSubmit={handleSubmit}>
                  <FormControl
                    isInvalid={
                      errors.organization_name && touched.organization_name
                    }
                  >
                    <FormLabel>Organization Name</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      ref={initialRef}
                      id="organization_name"
                      name="organization_name"
                      type="text"
                      placeholder="Orgnization Name"
                    />
                    <FormErrorMessage>
                      {errors?.organization_name}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.org_contact_person_first_name &&
                      touched.org_contact_person_first_name
                    }
                  >
                    <FormLabel>Contact Person First Name</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      ref={initialRef}
                      id="org_contact_person_first_name"
                      name="org_contact_person_first_name"
                      type="text"
                      placeholder="john"
                    />
                    <FormErrorMessage>
                      {errors?.org_contact_person_first_name}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.org_contact_person_last_name &&
                      touched.org_contact_person_last_name
                    }
                  >
                    <FormLabel>Contact Person Last Name</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      id="org_contact_person_last_name"
                      name="org_contact_person_last_name"
                      type="text"
                      placeholder="Doe"
                    />
                    <FormErrorMessage>
                      {errors?.org_contact_person_last_name}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.org_contact_person_phone_number &&
                      touched.org_contact_person_phone_number
                    }
                  >
                    <FormLabel>Contact Person Phone Number</FormLabel>
                    <PhoneInput
                      style={{
                        borderWidth: 1,
                        borderRadius: 5,
                        height: "30px",
                        paddingLeft: 8,
                      }}
                      placeholder="275 555 76"
                      defaultCountry="+91"
                      id="org_contact_person_phone_number"
                      name="org_contact_person_phone_number"
                      value={formatPhoneNumberIntl(
                        values?.org_contact_person_phone_number
                      )}
                      onChange={(phone) => {
                        setFieldValue("org_contact_person_phone_number", phone);
                      }}
                    />
                    <FormErrorMessage>
                      {errors?.org_contact_person_phone_number}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.org_contact_person_email &&
                      touched.org_contact_person_email
                    }
                  >
                    <FormLabel>Contact Person Email</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      id="org_contact_person_email"
                      name="org_contact_person_email"
                      type="email"
                      placeholder="john_doe@example.com"
                    />
                    <FormErrorMessage>
                      {errors?.org_contact_person_email}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.organization_address &&
                      touched.organization_address
                    }
                  >
                    <FormLabel>Location / Address</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      id="organization_address"
                      name="organization_address"
                      type="text"
                      placeholder="150 Lumsden Place, Waipatu, Hastings"
                    />
                    <FormErrorMessage>
                      {errors?.organization_address}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={errors.postal_code && touched.postal_code}
                  >
                    <FormLabel mt={4}>Postal Code</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      id="postal_code"
                      name="postal_code"
                      type="number"
                      onChange={(e) => {
                        setFieldValue("postal_code", String(e.target.value));
                      }}
                      placeholder="4122"
                    />
                    <FormErrorMessage>{errors?.postal_code}</FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={errors.authorization_code && touched.authorization_code} isDisabled={isFieldDisabled}
                  >
                    <FormLabel mt={4}>Authorization Code</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      id="authorization_code"
                      name="authorization_code"
                      type="text"
                      maxlength="6"
                      onChange={(e) => {
                        setFieldValue("authorization_code", String(e.target.value));
                      }}
                      placeholder="Modify Authorization Code"
                    />
                    <FormErrorMessage>{errors?.authorization_code}</FormErrorMessage>
                  </FormControl>
                  
                  {/* <FormControl
                    {...styles.formItem}
                    isInvalid={errors.privilege && touched.privilege}>
                    <FormLabel>Privilege</FormLabel>
                    <Select
                      {...styles.input}
                      placeholder="Select option"
                      name="privilege"
                      defaultValue={values.privilege}
                      onChange={(e) => {
                        handleChange(e.target.value);
                        console.log("e.target.value", e.target.value);
                        setFieldValue("privilege", e.target.value);
                      }}>
                      {roles.map((role) => {
                        return (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>{errors?.privilege}</FormErrorMessage>
                  </FormControl> */}

                  <ModelFooterButtons onClose={onClose} onSave={handleSubmit} />
                </form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

EditCustomerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  customer: PropTypes.object,
};
